import React from 'react'

import classNames from 'classnames'

import { IconWrapper } from '../components'

export const IconWifi = ({
  size,
  color,
  className,
  ...props
}: React.ComponentPropsWithoutRef<'svg'> & {
  size?: string | number
}) => (
  <IconWrapper {...props} className={classNames(className, "icon-centivo", "icon-centivo--wifi")} iconColor={color} size={size} width="24px" height="24px" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">

      <defs>
          <path d="M5.2300121,14.3201344 C8.93782269,11.2317999 14.3222015,11.2317999 18.0300121,14.3201344 C18.4543738,14.6735967 19.0849248,14.6161212 19.438387,14.1917595 C19.7918492,13.7673978 19.7343738,13.1368468 19.3100121,12.7833846 C14.8606394,9.07738313 8.39938481,9.07738313 3.9500121,12.7833846 C3.52565036,13.1368468 3.46817495,13.7673978 3.82163719,14.1917595 C4.17509943,14.6161212 4.80565036,14.6735967 5.2300121,14.3201344 Z M1.6615746,10.7516495 C7.33163517,5.74945016 15.838389,5.74945016 21.5084496,10.7516495 C21.9226024,11.1170204 22.5545313,11.0774748 22.9199021,10.663322 C23.285273,10.2491692 23.2457274,9.61724035 22.8315746,9.25186947 C16.4055059,3.58271018 6.76451825,3.58271018 0.3384496,9.25186947 C-0.0757032283,9.61724035 -0.115248811,10.2491692 0.250122069,10.663322 C0.615492949,11.0774748 1.24742177,11.1170204 1.6615746,10.7516495 Z M8.68917877,17.9269687 C10.4232011,16.6950297 12.7468231,16.6950297 14.4808454,17.9269687 C14.931073,18.2468336 15.5553563,18.1411538 15.8752213,17.6909262 C16.1950862,17.2406986 16.0894064,16.6164153 15.6391788,16.2965503 C13.2115476,14.5718358 9.95847664,14.5718358 7.53084543,16.2965503 C7.08061785,16.6164153 6.97493802,17.2406986 7.29480294,17.6909262 C7.61466786,18.1411538 8.23895118,18.2468336 8.68917877,17.9269687 Z" id="icon--centivo--wifi"/>
      </defs>
      <g id="Icons" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
          <g transform="translate(-384.000000, -1423.000000)"/>
          <g id="Icon/wifi">
              <mask id="mask-2" fill="white">
                  <use xlinkHref="#icon--centivo--wifi"/>
              </mask>
              <use id="Shape" fill="currentColor" xlinkHref="#icon--centivo--wifi"/>
          </g>
      </g>
  </IconWrapper>
)
